import { render, staticRenderFns } from "./StudentInformationAlertComponent.vue?vue&type=template&id=1b81afe2"
import script from "./StudentInformationAlertComponent.vue?vue&type=script&lang=js"
export * from "./StudentInformationAlertComponent.vue?vue&type=script&lang=js"
import style0 from "./StudentInformationAlertComponent.vue?vue&type=style&index=0&id=1b81afe2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports